export default __webpack_public_path__ + "static/image-39-8aaebae33fb7f355f3b6c87d8579cd3e.jpg";